import {makeAutoObservable} from "mobx";
import {Organization} from "../../entity/model/organization";
import OrganizationAgent from "../agent/organization-agent";

export default class OrganizationStore {
  organizations: Organization[] = [];
  cache: boolean = false;
  organizationAgent: OrganizationAgent;

  constructor(organizationAgent: OrganizationAgent) {
    makeAutoObservable(this);
    this.organizationAgent = organizationAgent;
  }

  getOrganizations = async (): Promise<Organization[]> => {
    try {
      this.organizations = await this.organizationAgent.getOrganizations();
      this.cache = true;
    } catch (error: any) {
      console.error('Error occurred while loading the organizations', error);
    }

    return this.organizations;
  }

  getOrganizationById = async (organizationId: string): Promise<Organization | undefined> => {
    try {
      return await this.organizationAgent.getOrganizationById(organizationId);
    } catch (error: any) {
      console.error('Error occurred while fetch organization by id:', organizationId, error);
    }
  }
}
